/* @generated */

// ../src/label_group/label_group.tsx
import * as React3 from "react";
import classnames from "classnames";
import { assignInlineVars } from "@vanilla-extract/dynamic";
import {
  vars,
  MediaObject
} from "@dropbox/dig-foundations";

// ../src/label_group/label_group.css.ts
var children = "dig-retfhw9_22-5-0";
var contentGapVar = "var(--dig-retfhw0_22-5-0)";
var defaultTypography = "dig-retfhw4_22-5-0";
var horizontal = "dig-retfhw8_22-5-0";
var isBlock = "dig-retfhw6_22-5-0";
var label = "dig-retfhw2_22-5-0";
var labels = "dig-retfhw1_22-5-0";
var largeLabelLineHeight = "dig-retfhw5_22-5-0";
var subText = "dig-retfhw3_22-5-0";
var vertical = "dig-retfhw7_22-5-0";

// ../src/label_group/label.tsx
import * as React from "react";
import clsx from "classnames";
import { Text } from "@dropbox/dig-components/typography";
var Label = ({
  children: children2,
  className,
  ...props
}) => {
  return /* @__PURE__ */ React.createElement(
    Text,
    {
      variant: "label",
      isBold: true,
      size: "medium",
      className: clsx(className, largeLabelLineHeight),
      ...props
    },
    children2
  );
};

// ../src/label_group/sub_text.tsx
import * as React2 from "react";
import clsx2 from "classnames";
import { Text as Text2 } from "@dropbox/dig-components/typography";
var SubText = ({
  children: children2,
  className,
  ...props
}) => {
  return /* @__PURE__ */ React2.createElement(
    Text2,
    {
      variant: "label",
      size: "medium",
      color: "subtle",
      className: clsx2(className, largeLabelLineHeight),
      ...props
    },
    children2
  );
};

// ../src/label_group/label_group.tsx
var LabelGroup = ({
  withLabel,
  withStartAccessory,
  withMeta,
  withSubText,
  className,
  direction = "vertical",
  verticalAlignment = "top",
  children: children2,
  labelGap: _labelGap,
  accessoryGap = "Micro Large",
  style,
  tagName: Tag = "div",
  htmlFor,
  _contentClassName,
  ...props
}) => {
  const labelGap = _labelGap ? _labelGap : direction === "vertical" ? "Micro XSmall" : "Micro Medium";
  const gapStyles = assignInlineVars({
    [contentGapVar]: vars.Spacing[labelGap]
  });
  const labelIsString = typeof withLabel === "string";
  const subTextIsString = typeof withSubText === "string";
  const shouldShowChildren = Boolean(children2 && direction === "vertical");
  const label2 = labelIsString ? /* @__PURE__ */ React3.createElement(Label, null, withLabel) : withLabel;
  const subText2 = subTextIsString ? /* @__PURE__ */ React3.createElement(SubText, null, withSubText) : withSubText;
  let childrenAlignY;
  if (direction === "horizontal") {
    childrenAlignY = "center";
  } else if (verticalAlignment === "offsetTop" && direction === "vertical") {
    childrenAlignY = "top";
  }
  return /* @__PURE__ */ React3.createElement(Tag, { htmlFor, className: isBlock }, /* @__PURE__ */ React3.createElement(
    MediaObject,
    {
      withAccessory: withStartAccessory,
      accessoryGap,
      alignY: verticalAlignment === "offsetTop" ? "top" : verticalAlignment,
      childrenOffset: verticalAlignment === "offsetTop" ? "4" : void 0,
      childrenAlignY,
      style: { ...style, ...gapStyles },
      className,
      ...props
    },
    /* @__PURE__ */ React3.createElement(
      "span",
      {
        className: classnames(_contentClassName, labels, isBlock, defaultTypography, {
          [vertical]: direction === "vertical",
          [horizontal]: direction === "horizontal"
        })
      },
      /* @__PURE__ */ React3.createElement("span", { className: classnames(isBlock, label) }, label2),
      withSubText ? /* @__PURE__ */ React3.createElement("span", { className: classnames(isBlock, subText) }, subText2) : null,
      withMeta ? /* @__PURE__ */ React3.createElement("span", { className: isBlock }, withMeta) : null
    ),
    shouldShowChildren && /* @__PURE__ */ React3.createElement("span", { className: classnames(children, isBlock) }, children2)
  ));
};

// ../src/label_group/index.ts
var LabelGroupNamespace = Object.assign(LabelGroup, {
  Label,
  SubText
});
export {
  LabelGroupNamespace as LabelGroup
};
